var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CSSTransition } from 'react-transition-group';
var Transition = /** @class */ (function (_super) {
    __extends(Transition, _super);
    function Transition(props) {
        var _this = _super.call(this, props) || this;
        _this.onEnter = function () {
            _this.props.onEnter();
        };
        _this.onEntering = function () {
            _this.props.onEntering();
        };
        _this.onEntered = function () {
            _this.props.onEntered();
        };
        _this.onExit = function () {
            _this.props.onExit();
        };
        _this.onExiting = function () {
            _this.props.onExiting();
        };
        _this.onExited = function () {
            _this.props.onExited();
        };
        return _this;
    }
    Object.defineProperty(Transition.prototype, "children", {
        get: function () {
            var _a = this.props, children = _a.children, timeout = _a.timeout;
            var currentChildren = children;
            if (children.constructor !== Function) {
                var _b = children.props, _c = _b.className, className = _c === void 0 ? '' : _c, _d = _b.style, style = _d === void 0 ? {} : _d;
                currentChildren = React.cloneElement(children, {
                    className: "animated " + className,
                    style: __assign({
                        '--webkit-animation-duration': timeout + "ms",
                        animationDuration: timeout + "ms",
                    }, style),
                });
            }
            return currentChildren;
        },
        enumerable: false,
        configurable: true
    });
    Transition.prototype.render = function () {
        var _a = this.props, isIn = _a.in, timeout = _a.timeout, unmountOnExit = _a.unmountOnExit, classNames = _a.classNames;
        return (React.createElement(CSSTransition, { in: isIn, timeout: timeout, classNames: classNames, unmountOnExit: unmountOnExit, onEnter: this.onEnter, onEntering: this.onEntering, onEntered: this.onEntered, onExit: this.onExit, onExiting: this.onExiting, onExited: this.onExited }, this.children));
    };
    Transition.defaultProps = {
        in: true,
        timeout: 1000,
        unmountOnExit: true,
        classNames: '',
        onEnter: function () { },
        onEntering: function () { },
        onEntered: function () { },
        onExit: function () { },
        onExiting: function () { },
        onExited: function () { },
    };
    return Transition;
}(React.Component));
export { Transition };
